module.exports = __webpack_public_path__ + "img/gear.918d2cca.svg";